import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import {
  catchError,
  distinctUntilChanged,
  filter,
  map,
  switchMap
} from 'rxjs/operators';
import { StateFacade as OverviewFacade } from '../../facades/state.facade';
import { PersonalizationEngineService } from '../../services/api/personalization-engine.service';
import { getMultiplePERequest } from '../../utils/common-pe-request.utils';
import * as OverviewActions from '../actions/api.actions';

@Injectable()
export class PersonalizationEngineEffects {
  loadMultiplePEData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OverviewActions.loadMultiplePE),
      switchMap(() =>
        this.overview.trackerContent$.pipe(
          filter((trackerContent) => !!trackerContent),
          switchMap((trackerContent) =>
            this.overview.peRequest$.pipe(
              distinctUntilChanged(
                (previous, current) =>
                  JSON.stringify(previous) === JSON.stringify(current)
              ),
              switchMap((payload) => {
                const stateParam = trackerContent;
                const requestParams = getMultiplePERequest(payload, stateParam);
                return this.pe.getMultipleContent(requestParams).pipe(
                  map((content) =>
                    OverviewActions.loadMultiplePESuccess({
                      personalizationEngine: {
                        id: 'multiple-pe-content',
                        multiplePEContent: content
                      }
                    })
                  ),
                  catchError(() =>
                    of(
                      OverviewActions.loadMultiplePEFailure({
                        error: {
                          id: 'multiple-pe-content-error',
                          multiplePEContentError: 'multiple-pe'
                        }
                      })
                    )
                  )
                );
              })
            )
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private readonly pe: PersonalizationEngineService,
    private readonly overview: OverviewFacade
  ) {}
}
